export default {
  model: {
    created: {
      notes: 'Created property for equipment configuration value',
      message: 'When',
    },
    creator: {
      notes: 'Creator property for equipment configuration value',
      message: 'Who',
    },
    value: {
      notes: 'Value property for equipment configuration value',
      message: 'What',
    },
  },
  action: {
    showHistory: {
      notes: 'Show history for equipment configuration property',
      message: 'History',
    },
  },
  history: {
    header: {
      notes: 'Header when listing equipment configuration history',
      message: 'History',
    },
  },
};
